module.exports = "/images/caret-round.svg?62ded8f273d5c70994c72758fdc98bc5";